"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum for the message Adtype
 */
var MessageAdType;
(function (MessageAdType) {
    MessageAdType["OutlookUpSell"] = "OutlookUpSell";
    MessageAdType["BingOneClick"] = "BingOneClick";
    MessageAdType["BingOneClickOIO"] = "BingOneClickOIO";
    MessageAdType["BingTwoClick"] = "BingTwoClick";
    MessageAdType["AppNexusOneClick"] = "AppNexusOneClick";
    MessageAdType["AppNexusOneClickOIO"] = "AppNexusOneClickOIO";
    MessageAdType["AppNexusTwoClick"] = "AppNexusTwoClick";
    MessageAdType["TaboolaOneClick"] = "TaboolaOneClick";
    MessageAdType["TaboolaOneClickOIO"] = "TaboolaOneClickOIO";
    MessageAdType["TaboolaTwoClick"] = "TaboolaTwoClick";
    MessageAdType["PrebidOneClick"] = "PrebidOneClick";
    MessageAdType["PrebidOneClickOIO"] = "PrebidOneClickOIO";
})(MessageAdType || (MessageAdType = {}));
exports.default = MessageAdType;
//# sourceMappingURL=MessageAdType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-messagead-store/lib/store/schema/MessageAdType.js
// module id = 3458
// module chunks = 17 67